module.exports = __webpack_public_path__ + "static/media/Logo-Skjaergaardstjenesten.50b60f24.png";